import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";
import { showToast } from "../components/ui/toast";

// Fetch the LogicalPrice document
export const useGetLogicalPriceQuery = () => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_LOGICAL_PRICE],
    queryFn: () => api.get(API_ROUTES.GET_LOGICAL_PRICE),
  });

  return { data: data?.data?.data.items ?? null, isPending, isError, error };
};

// Add a new item to LogicalPrice
export const useAddLogicalPriceMutation = () => {
  const queryClient = useQueryClient();

  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (data) =>
        api.post(API_ROUTES.ADD_LOGICAL_PRICE, data),
      onSuccess: () => {
        showToast("success", "Item added successfully");
        queryClient.invalidateQueries(API_ROUTES.GET_LOGICAL_PRICE);
      },
    });

  return { mutate, isError, error, isLoading, isSuccess, isPending };
};

// Update an existing item in LogicalPrice
export const useUpdateLogicalPriceMutation = () => {
  const queryClient = useQueryClient();

  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (data) =>
        api.put(API_ROUTES.EDIT_LOGICAL_PRICE.replace(":id", data?.id), {
          name: data?.name,
          percentage: data?.percentage,
          description: data?.description,
        }),
      onSuccess: () => {
        showToast("success", "Item updated successfully");
        queryClient.invalidateQueries(API_ROUTES.GET_LOGICAL_PRICE);
      },
    });

  return { mutate, isError, error, isLoading, isSuccess, isPending };
};

// Delete an item from LogicalPrice
export const useDeleteLogicalPriceMutation = () => {
  const queryClient = useQueryClient();

  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (id) =>
        api.delete(API_ROUTES.DELETE_LOGICAL_PRICE.replace(":id", id)),
      onSuccess: () => {
        showToast("success", "Item deleted successfully");
        queryClient.invalidateQueries(API_ROUTES.GET_LOGICAL_PRICE);
      },
    });

  return { mutate, isError, error, isLoading, isSuccess, isPending };
};
